(ns ycweb.app.admin.tasks.forms.incident
  (:require
   [rum.core :as rum]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.transitions :as t]))

(rum/defc incident-form < rum/reactive cmn/cursors [app-atom]
  [:<>
   [:script {:src "https://static.airtable.com/js/embed/embed_snippet_v1.js"}]
   [:iframe
    {:class "airtable-embed airtable-dynamic-height"
     :src "https://airtable.com/embed/shrGROrNwdRfQtUks?backgroundColor=tealLight"
     :frameborder "0"
     :onmousewheel ""
     :width "100%"
     :height "2036"
     :style {:background "transparent" :border "none"}}]])

(defmethod t/transition-after-open :admin.tasks/incident-form [app-atom _ _]
  (dcommon/kill-search-bar)
  (presence/open app-atom {:context/ident :admin.tasks}))

(defmethod flow/render-screen :admin.tasks/incident-form [app-atom _]
  (incident-form app-atom))
